import { render } from "./LocationCell.vue?vue&type=template&id=3c01f57c&scoped=true"
import script from "./LocationCell.vue?vue&type=script&lang=js"
export * from "./LocationCell.vue?vue&type=script&lang=js"

import "./LocationCell.vue?vue&type=style&index=0&id=3c01f57c&lang=scss&scoped=true"

import exportComponent from "/Users/soil2sons/Projects/Work/Ensibuuko/hrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c01f57c"]])

export default __exports__